import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import * as Sentry from '@sentry/angular';

export const sentryHttpInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      Sentry.logger.error(Sentry.logger.fmt`HTTP Error ${error.status} "${error.error?.message}"`, {
        request: req.body,
        response: error.error,
        httpStatus: error.status,
        url: req.url,
        method: req.method,
        origin: window.location.href,
      });

      // Re-throw the error so components/services still know the request failed
      return throwError(() => error);
    }),
  );
};
